import { render, staticRenderFns } from "./AddressPanel.vue?vue&type=template&id=d2e06bfa&scoped=true&"
import script from "./AddressPanel.vue?vue&type=script&lang=js&"
export * from "./AddressPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddressPanel.vue?vue&type=style&index=0&id=d2e06bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e06bfa",
  null
  
)

export default component.exports